import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoWhatInBox from 'eco-design/sections/eco-what-in-box';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.WhatInBox');

    const items = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778518246/a1.png',
            title: t('item1')
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778539446/a2.png',
            title: t('item2'),
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778553535/a3.png',
            title: t('item3')
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780284895/a5.png',
            title: t('item4')
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780302139/a6.png',
            title: t('item5')
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778567429/a4.png',
            title: t('item6')
        }
    ];

    return (
        <div className={styles.comp} id="WhatInBox">
            <EcoSpace />
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <EcoWhatInBox items={items} />
            <EcoSpace />
        </div>
    );
}